export const CATEGORY_MAPPER = {
  active: 'active',
  mind: 'mind',
  recovery: 'recovery',
  live: 'live',
  solo: 'solo',
  'custom session': 'custom session',
}
